import React, { useEffect, useState, useContext } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import SunEditor from 'suneditor-react';

import StudentContext from '../../../context/student-context';
import { SubmitNoAssessmentLearningContent, SubmitLearningContentEmoji, GetLearningContentByLearningContentId, postAssessment, postAssessmentNR } from '../../../actions/learningcontent-actions';
import { getStudentCoins } from '../../../actions/share-actions';
import Loading from '../../shared/Loading';
import { ButtonTakeAssessment, InputSecretCode, DialogLearningContent } from '../../shared/component'
import FlyingCoinAnimationModal from '../../shared/modals/FlyingCoinAnimationModal'

import useStyles from '../../../styles/components/learningcontent/stylesLearningContentDetailsHolder'
import getIconEmojiLearningContent from '../../../utils/helpers/icon/EmojiHelper'
import { AssementData, StudentProfile } from '../../../utils/services/cache/ClientCache'
import { getLearningContentFromSession, getLearningContentLevel, getStudentNumberFromSession, getTime, setTime } from '../../../utils/helpers/others/SessionHelper';

const LearningContentDetailsHolder = ({ learningContentDetails, updateLC }) => {

    const history = useHistory();
    const [secretCode, setSecretCode] = useState('')
    const classes = useStyles()
    const [open, setOpen] = React.useState(false);
    const [notiOpen, setNotiOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [assementRewardPoint, setAssementRewardPoint] = React.useState(0);
    const [chooseEmoji, setChooseEmoji] = React.useState(null);
    const [messageReward, setMessageReward] = React.useState('')
    const { dispatchStudent } = useContext(StudentContext);
    const studentNumber = getStudentNumberFromSession();
    const learningContentSession = JSON.parse(getLearningContentFromSession());
    let currentRewardPoint = StudentProfile.getRewardPoint();
    const startTime = getTime()
    const endTime = new Date().getTime()

    const [snackBarDetails, setSnackBarDetails] = React.useState({
        open: false,
        message: '',
        type: '',
    });

    const handleSnackBarClose = () => setSnackBarDetails({ ...snackBarDetails, open: false });

    const inputSnackBarDetails = (message, type) => setSnackBarDetails({
        open: true,
        message,
        type
    });

    useEffect(() => {
        if (Object.keys(learningContentDetails).length !== 0 && learningContentDetails.learningContentEmoji !== null) {
            iconEmoji().map(emoji => {
                if (emoji.emojiId === learningContentDetails.learningContentEmoji.emojiId) {
                    setChooseEmoji(emoji)
                }
            })
        }
    }, [learningContentDetails])

    const iconEmoji = () => {
        return [
            { emojiId: "Happy", emoji: getIconEmojiLearningContent().happy },
            { emojiId: "Motivated", emoji: getIconEmojiLearningContent().motivated },
            { emojiId: "Sad", emoji: getIconEmojiLearningContent().sad },
        ]
    }

    const takeAssement = () => {

        AssementData.setAssementTitle(learningContentDetails.title);
        AssementData.setAssementTraitGroupId(learningContentDetails.traitGroupId);
        AssementData.setAssementRewardPoint(learningContentDetails.coins);
        AssementData.setAssementTypeId(learningContentDetails.assessmentTypeId);
        AssementData.setAssementTypeName(learningContentDetails.assessmentTypeName);
        return history.push("/Assessment")
    }

    const submitNoAssement = async () => {
        setIsLoading(true);
        let rewardPoint = learningContentDetails.coins;
        let bodyFormData = {
            learningContentId: learningContentSession.learningContentId,
            traitGroupId: learningContentDetails.traitGroupId,
            rewardCoins: learningContentDetails.coins,
            studentNumber: studentNumber
        };

        let response = await SubmitNoAssessmentLearningContent(JSON.stringify(bodyFormData));
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        setIsLoading(false);
        setNotiOpen(true);
        setAssementRewardPoint(rewardPoint);
    }

    const handleClose = () => {
        setSecretCode('')
        if (learningContentSession.learningContentCategoryId === 0)
            return history.push("/NonTraitLearningContents");
        else
            return history.push("/LearningContents");

    };

    const notiCloseClick = async () => {
        // update coin for Drawer Header
        const responseCoin = await getStudentCoins();
        if (responseCoin.status === "Success") {
            dispatchStudent({ type: 'SET_STUDENT_COINS', studentCoins: responseCoin.data });

        }
        setNotiOpen(false);
        setOpen(true);
    }

    const submitEmoji = async (bodyFormData) => {
        const submitEmoji = await SubmitLearningContentEmoji(bodyFormData)
        if (submitEmoji > 200 || submitEmoji.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        const learningContentResponse = await GetLearningContentByLearningContentId(bodyFormData.LearningContentId);
        if (learningContentResponse > 200 || learningContentResponse.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        updateLC(learningContentResponse.data)
    }

    const handleChooseEmoji = (id_emoji) => {
        const bodyFormData = {}
        bodyFormData.LearningContentId = learningContentDetails.learningContentId;
        bodyFormData.EmojiId = id_emoji;
        if (learningContentDetails.learningContentEmoji !== null) {
            bodyFormData.UnLikeId = learningContentDetails.learningContentEmoji.id;
        }
        if (chooseEmoji && chooseEmoji.emojiId === id_emoji) {
            submitEmoji(bodyFormData)
            return setChooseEmoji(null)
        }
        const choosenEmoji = iconEmoji().filter(item => item.emojiId === id_emoji)[0]
        setChooseEmoji(choosenEmoji)
        submitEmoji(bodyFormData)
    }

    const statisticEmoji = (value) => {
        if (value) {
            return (
                <div className="emoji--container">
                    <Tooltip title="Happy" placement="top">
                        <div className="emoji__item">
                            <div className="emoji__item--icon">
                                <img src={getIconEmojiLearningContent().happy} />
                            </div>
                            <div className="emoji__item--count emoji__item--happy">{` ${value.countHappy}`}</div>
                        </div>
                    </Tooltip>
                    <Tooltip title="Motivated" placement="top">
                        <div className="emoji__item">
                            <div className="emoji__item--icon">
                                <img src={getIconEmojiLearningContent().motivated} />
                            </div>
                            <div className="emoji__item--count emoji__item--motivated">{` ${value.countMotivated}`}</div>
                        </div>
                    </Tooltip>
                    <Tooltip title="Sad" placement="top">
                        <div className="emoji__item">
                            <div className="emoji__item--icon">
                                <img src={getIconEmojiLearningContent().sad} />
                            </div>
                            <div className="emoji__item--count emoji__item--sad">{` ${value.countSad}`}</div>
                        </div>
                    </Tooltip>
                </div>
            )
        }
    }

    const handleSubmitCode = async () => {
        let bodyFormData = {
            learningContentId: learningContentSession.learningContentId,
            totalScore: 0,
            score: 0,
            secretCodeText: secretCode,
            assessmentTypeName: 'Secret Code',
            studentNumber: studentNumber,
            isSecretCode: true,
            traitGroupId: learningContentDetails.traitGroupId,
            rewardCoins: learningContentDetails.coins,
            duration: Math.round((endTime - startTime) / 1000)
        };
        // console.log(learningContentDetails);
        let response = null
        if(learningContentSession.traitGroupid === 0 || learningContentSession.isRecommended === true){
            response = await postAssessment(JSON.stringify(bodyFormData));
        }else{
            response = await postAssessmentNR(JSON.stringify(bodyFormData));
        }
        if (response > 200 || response.status === "Failed") {
            return history.push("/SessionTimeOut")
        }

        setIsLoading(false);

        if (parseInt(response.data.coinEarned) > 0) {
            setNotiOpen(true);
            setAssementRewardPoint(response.data.coinEarned);
            setMessageReward(response.data.message)
            setTime(new Date().getTime())
        }
        else {
            inputSnackBarDetails(response.data.message, 'error');
        }
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            handleSubmitCode()
        }
    }

    const handleChange = (e) => setSecretCode(e.target.value)

    if (isLoading) return <Loading />

    return (
        
            <Grid container direction={'column'} alignContent={'center'} justify={'center'} >
                <Grid container justify={'space-between'} classes={{ root: classes.rootGridContentContainer }}>
                    <Typography variant="subtitle1" classes={{ root: classes.rootTitle }}>
                        {learningContentDetails.title}
                    </Typography>
                    <div className="emoji_count">
                        {statisticEmoji(learningContentDetails.statisticLearningContentEmojiModel)}
                    </div>
                </Grid>

                <Grid classes={{ root: classes.customLayoutVideo }}>
                <SunEditor
                        showToolbar={false}
                        enableToolbar={false}
                        disable={true}
                        setOptions={{
                            height: "100%",
                            resizingBar: false,
                        }}
                        toggleFullScreen={true}
                        setContents={learningContentDetails.resourceContent}
                        showController={false}
                    />
                </Grid>
                <Typography variant="body2" classes={{ root: classes.rootTitle }} align={'center'} paragraph={true}>
                    How do you feel about this Learning Content?
            </Typography>
                <div className="emoji_container">
                    <div className="emoji_wrapper">
                        <div className="emoji_list">
                            {iconEmoji().length !== 0 && iconEmoji().map((emoji, idx) => (
                                <Tooltip title={emoji.emojiId} key={idx}>
                                    <div
                                        className={`emoji_item_wrapper ${chooseEmoji && emoji.emojiId === chooseEmoji.emojiId ? 'emoji_item_wrapper_active' : ''}`}
                                        onClick={() => handleChooseEmoji(emoji.emojiId)}
                                    >
                                        <div className={`emoji_item emoji_${idx}`}>
                                            <img src={emoji.emoji} />
                                        </div>
                                    </div>
                                </Tooltip>
                            ))}
                        </div>
                    </div>
                </div>

                {
                    <Grid container
                        direction={'row'}
                        alignContent={'center'}
                        justify={'center'}
                        className="learningcontentdetail__item__detail">
                            {/**
                             * If learningContent is completed, dont allow student to redo
                             * However, if learningContent is not completed, even if "Inaccessible", the student still can do content.
                             * But this will mark it in the assessment to submit to the non-recommended endpoint instead.
                             */}
                        {learningContentDetails && (() => {
                            // if (learningContentSession.isAccessible) {
                            if (learningContentDetails.assessmentTypeName === 'Multiple Choice and Secret Code' || learningContentDetails.assessmentTypeName === 'Multiple Answers and Secret Code') {
                                // console.log(learningContentSession);
                                // console.log(learningContentDetails);
                                return (
                                    <>
                                    <Grid container justify="center" alignItems="flex-start">
                                    {learningContentSession.isCompleted === true ? <></>:                                         
                                            <ButtonTakeAssessment
                                                text="Take Assessment"
                                                onClick={() => takeAssement()}
                                                coin={learningContentDetails.coins}
                                                takeAssement={true}
                                            />
                                    }
                                    <div style={{ margin: '10px' }} />                                                                        
                                    {learningContentSession.isSecretCodeClaim === true ? 
                                        <></>
                                        :
                                        <InputSecretCode
                                            placeholder="Secret Code"
                                            secretCode={secretCode}
                                            onClick={() => handleSubmitCode()}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(e) => onKeyDown(e)}
                                            takeAssement={true}
                                        /> 
                                    }
                                        </Grid>
                                    </>
                                )
                            } else if (learningContentDetails.hasAssessment) {
                                return (
                                    <>
                                    {
                                    learningContentSession.isCompleted ? 
                                        <></>
                                        :
                                        <Grid container justify="center" alignItems="flex-start">
                                            <ButtonTakeAssessment
                                                text="Take Assessment"
                                                onClick={() => takeAssement()}
                                                coin={getLearningContentLevel() < 1 ? 0 : 
                                                    learningContentSession.isRecommended !== true ? 0 : 
                                                    learningContentDetails.coins}
                                                takeAssement={true}
                                            />
                                            {
                                            learningContentSession.isAccessible === false ?
                                                <div style = {{width : '300px', color: 'red', marginLeft : '20px', fontWeight: 'bold', textAlign: 'left'}}>
                                                    Please note that coins are only rewarded for recommended content.
                                                </div>
                                                : 
                                                <></>
                                            }
                                        </Grid>
                                    }
                                    </>
                                )
                            } else {
                                return (
                                    <ButtonTakeAssessment
                                        text="Complete"
                                        onClick={() => submitNoAssement()}
                                        coin={learningContentDetails.coins}
                                        takeAssement={false}
                                    />
                                )
                            }
                            // }
                        })()
                        }
                    </Grid>
                }


                <DialogLearningContent
                    open={open}
                    handleCatalogClick={() => handleClose()}
                    code={!learningContentDetails.hasAssessment ? '' : secretCode}
                    coinEarn={assementRewardPoint}
                    coinBalance={parseInt(currentRewardPoint) + assementRewardPoint}
                    message={!learningContentDetails.hasAssessment ? 'You just earned reward point for completing the learning content.' : messageReward}
                    titleContent={!learningContentDetails.hasAssessment ? '' : learningContentDetails.title}
                />

                <Snackbar
                    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                    key={`bottom, center`}
                    open={snackBarDetails.open}
                    autoHideDuration={6000}
                    onClose={handleSnackBarClose}>
                    <Alert onClose={handleSnackBarClose} severity={snackBarDetails.type}>
                        {snackBarDetails.message}
                    </Alert>
                </Snackbar>

                <FlyingCoinAnimationModal _isOpen={notiOpen} _notiCloseClick={notiCloseClick} _extraContent={{ rewardPoint: assementRewardPoint }} />

            </Grid>
    )
}

export default LearningContentDetailsHolder;